export default "__VITE_ASSET__BwBeegZe__"